$(document).ready(function() {
	 var resizeTimeout = null;
	// Opening new tab for external link
	var $hostname = window.location.hostname;
	$('a[href^="http://"],a[href^="www."]').not('a[href^="http://'+ $hostname +'"],a[href^="'+ $hostname +'"]').attr('target','_blank');

	$('#lening_berekenen').find('input[type="submit"], .change-verzekering').on('click', function(e){
		if( (!$('#lening_berekenen').attr('action') || $('#lening_berekenen').find('.orv-input')) && $('#verzekering_berekenen').length > 0 ) {
			$('html,body').animate({
				scrollTop: $('#verzekering_berekenen').offset().top - 200
			});
		}
	});

	$('#lead-keuren').find('input').on('blur', function(){
		var postcode = $('input[name="postcode"]').val();
		var huisnummer = $('input[name="huisnummer"]').val();


		$.ajax({
			url: '/postback/getClickId/?postcode='+postcode+'&huisnummer='+huisnummer,
			success: function(data)
			{
				$('input[name="clickidoa"]').val(data);
			}
		});


	});

	$('.read-more-tag').on('click', function(){
		if($(this).hasClass('close')){
			$(this).parent().find('.read-more').hide();
			$('.equalize').each(function(){
				equalizeHeights($(this));
			});
			$(this).text('Lees minder');
			$(this).removeClass('close');
		} else {
			$(this).parent().find('.read-more').show();
			$('.equalize').each(function(){
				equalizeHeights($(this));
			});
			$(this).text('Lees minder');
			$(this).addClass('close');
		}
	});

	function equalizeHeights(element)
	{
		//Only fire equalize script if the screen width is tablet or above
		if($(window).width() > 767){
			element.find('.equalize-item').height('auto');
			var equalizeItemHeight = Math.max.apply(null, element.find('.equalize-item').map(function ()
			{
				return $(this).height();
			}).get());

			element.find('.equalize-item').height(equalizeItemHeight);
		}else{
			element.find('.equalize-item').height('auto');
		}
	}

	$('.equalize').each(function(){
		equalizeHeights($(this));
	});

	$(window).resize(function() {
	//Wait until the user is done resizing the window
	if (resizeTimeout) { window.clearTimeout(resizeTimeout); }

		resizeTimeout = window.setTimeout(function(){
			$('.equalize').each(function(){
				equalizeHeights($(this));
			});
		},  150);
	});

	$("#close-alert" ).live('click', function() {
	  	$(this).parents('div.info-box').fadeOut();
	});

	$('#cookie-bar .cookie-actions a').on('click',function(){
		document.cookie = "cookieAccept=True; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;";
		$('#cookie-bar').addClass('close');
		setTimeout(function(){
			$('#cookie-bar').hide();
		}, 300);
	});
	$('#select-blog-category').change(function() {
		window.location = $(this).val();
	});
	$('.section.blog .blog-item__content a').click(function() {
		if($(window).width() > 767){
			$(this).attr('target', '_blank');
		}else {
			$(this).removeAttr('target');
		}
	});

	if(browserIsIE()) {
		$('.blog-item__image img').each(function(){
			var imageSource = $(this).attr('src');
			$(this).parent().css('background-image','url("'+imageSource+'")');
			$(this).remove();
		});
	}
});
$(window).load(function(){
	$("#goto-rente-table, .goto-rente-table").click(function() {
	    $('html, body').animate({
	        scrollTop: $("#vergelijk-rentes").offset().top - 100
	    }, 500);
	});

	$("#goto-rente-table-btn").click(function() {
	    $('html, body').animate({
	        scrollTop: $("#top3").offset().top - 100
	    }, 500);
	});
});

function browserIsIE() {

	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
	{
		return true;
	}

	return false;
}

Bugsnag.apiKey = "1b1d9ee7263194f483e973d735f1295b";
Bugsnag.releaseStage = "development JS";

Bugsnag.beforeNotify = function(payload) {
	var isInterneLink = payload.file.match(/(nederlandskredietcollectief.nl)/gi);
	var externalSrc = payload.url.match(/(nederlandskredietcollectief.nl)/gi);

	// Stop the error from reporting if it doesn't come from an internal link e.g. "https://www.google-analytics.com/analytics.js"
	if(!isInterneLink || !externalSrc){
		return false;
	}
};